import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserNotification } from '../../api/notificationsApi';
import { usePapeis } from '../../hooks/usePapeis';
import { telaDaNotificacao } from '../../shared/notificacoes-por-tela';
import { enderecoDaReferencia } from './referenciaDoAviso';
import { alcancaPathPelosPapeis } from '../sidebar/Sidebar';
import SinoNotificacoes from './SinoNotificacoes';

/**
 * O sino ÚNICO do sistema, fixo no topo de todas as telas internas (transversal/at-90).
 *
 * Pedido do Victor (23/10/2026): entrando como ADMIN, "não passou sensação de notificação
 * nenhuma" — o sino vivia dentro de três telas e, fora delas, o aviso era um número perdido numa
 * Sidebar longa. Este sino substitui os de dentro das telas, e liga o modo `global` (toast por
 * aviso novo, resumo ao entrar e o contador no título da aba).
 *
 * O clique leva ao aviso por URL, não por callback de tela — é o que permite abrir de qualquer
 * lugar:
 * - pedido/requisição: o link direto do Dashboard de Compras (`?pedido=` / `?requisicao=`);
 * - veículo: a tela do aviso (a mesma regra do número do menu) com `?placa=`, que a tela lê e
 *   aplica na busca.
 */
const SinoDoTopo: React.FC = () => {
  const navigate = useNavigate();
  const papeis = usePapeis();

  const aoAbrirAviso = useCallback(
    (n: UserNotification) => {
      // Aviso de módulo satélite (Portal de Cotações, Requisições) já traz a tela que abre.
      if (n.destino) {
        navigate(n.destino);
        return;
      }
      if (n.referenciaTipo && n.referenciaId) {
        navigate(enderecoDaReferencia(n.referenciaTipo, n.referenciaId));
        return;
      }
      const tela = telaDaNotificacao(n, (path) => alcancaPathPelosPapeis(papeis, path));
      if (!tela) return;
      navigate(n.carPlate ? `${tela}?placa=${encodeURIComponent(n.carPlate)}` : tela);
    },
    [navigate, papeis],
  );

  return (
    <div className="sino-do-topo">
      <SinoNotificacoes global aoAbrirAviso={aoAbrirAviso} />
    </div>
  );
};

export default SinoDoTopo;
